/**
 * Coerce react-hook-form / persisted imageCapture values into an array for UI.
 * Table cells and legacy saves may store a single object or JSON string instead of an array.
 */
export function normalizeImageCaptureList(raw: unknown): unknown[] {
  if (raw == null || raw === "") return [];
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (typeof raw === "object") return [raw];
  if (typeof raw === "string") {
    const t = raw.trim();
    if (!t) return [];
    if (t.startsWith("[") || t.startsWith("{")) {
      try {
        return normalizeImageCaptureList(JSON.parse(t));
      } catch {
        return [];
      }
    }
    return [];
  }
  return [];
}
